import React, { useState } from 'react';
import { Layout } from 'antd';
import { useLocation } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import { AnalyticsDashboard } from '../analytics';
import AdminDashboard from '../../../pages/admin/AdminDashboard';
import { UserManagement } from '../management';
import { QuotesManagement } from '../../features/services';
import AdminSettings from './AdminSettings';
import { theme } from '../../../styles/theme';

const { Content } = Layout;

const AdminLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const location = useLocation();

  // Determine which content to show based on current route
  const renderContent = () => {
    switch (location.pathname) {
      case '/analytics':
        return <AnalyticsDashboard />;
      case '/admin/users':
        return <UserManagement />;
      case '/admin/quotes':
        return <QuotesManagement />;
      case '/admin/settings':
        return <AdminSettings />;
      case '/admin':
      default:
        return <AdminDashboard />;
    }
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <AdminSidebar 
        collapsed={sidebarCollapsed} 
        onCollapse={setSidebarCollapsed}
      />
      <Layout style={{ 
        marginLeft: sidebarCollapsed ? 80 : 250,
        transition: 'margin-left 0.2s',
        backgroundColor: theme.colors.lightGray
      }}>
        <Content style={{
          padding: '24px',
          minHeight: '100vh'
        }}>
          {renderContent()}
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
